/**
 * Footer Element Visibility Rules
 * 
 * Controls visibility of footer CTA elements (LISTING_HERO experiment).
 */

import { AllowedExperimentKey } from '@tenants/types';
import { ExperimentElement, type VisibilityRule } from '../../types';

/**
 * Footer element visibility rules
 * 
 * Logic:
 * - Sticky Footer: Mobile-only sticky action buttons (v2 redesign)
 *   - Only show on mobile when LISTING_HERO experiment is active
 *   - Legacy doesn't have sticky footer
 */
export const footerRules: Partial<Record<ExperimentElement, VisibilityRule>> = {
  [ExperimentElement.STICKY_FOOTER]: {
    showWhen: {
      experiments: [AllowedExperimentKey.LISTING_HERO],
      viewports: ['mobile'],
    },
  },
};
